import {multiLineString as multilineStringFN} from "@turf/helpers";

export default function turfmultiLineString(coordinates, properties, options) {
    return multilineStringFN(coordinates, properties, options);
}
